import { FC } from 'react'
import { BoxProps } from '@mui/material/Box'
import TechStethoscope from './TechStethoscope'
import TechChat from './TechChat'
import TechDoctor from './TechDoctor'
import TechHeart from './TechHeart'
import TechHospital from './TechHospital'
import TechPersonalInformation from './TechPersonalInformation'
import { IIllustration } from '../typings'
import HomeBanner from './HomeBanner'
import ComputerLaptop from './ComputerLaptop'
import ExploreMagnify from './ExploreMagnify'
import HeartHug from './HeartHug'
import DoctorSnapshot from './DoctorSnapshot'
import MobileCare from './MobileCare'
import Lock from './Lock'
import EditPencil from './EditPencil'
import LightHouse from './LightHouse'
import WalkingGroup from './WalkingGroup'
import NoteTaking from './NoteTaking'
import NavigatingCare from './NavigatingCare'
import Hug from './Hug'
import FemaleStethoscope from './FemaleStethoscope'
import FemaleStethoscopeFull from './FemaleStethoscopeFull'
import OBGYNDoctor from './OBGYNDoctor'
import AdultPrimaryCareDoctor from './AdultPrimaryCareDoctor'
import CommunicationStyle from './CommunicationStyle'
import CareApproach from './CareApproach'
import BackgroundIdentities from './BackgroundIdentities'
import ClinicAmenities from './ClinicAmenities'
import CommunicatingStyleNew from './CommunicatingStyleNew'
import CareApprochNew from './CareApprochNew'
import SharedBackground from './SharedBackground'
import ClinicalAminitiesNew from './ClinicalAminitiesNew'
import CommunicationStyleSm from './CommunicationStyleSm'
import CommunicationStyleMd from './CommunicationStyleMd'
import BackgroundIdentitiesSm from './BackgroundIdentitiesSm'
import BackgroundIdentitiesMd from './BackgroundIdentitiesMd'
import CareApproachSm from './CareApproachSm'
import CareApproachMd from './CareApproachMd'
import ClinicAmenitiesMd from './ClinicAmenitiesMd'
import ClinicAmenitiesSm from './ClinicAmenitiesSm'
import USMap from './USMap'
import AdminPortal from './AdminPortal'
import Heart from './Heart'
import Videochat from './Videochat'
import Stopwatch from './Stopwatch'

const Illustration: FC<{ name: IIllustration } & BoxProps<'svg'>> = ({
  name,
  ...boxProps
}) => {
  let Comp: FC<BoxProps<'svg'>>
  switch (name) {
    case 'chat':
      Comp = TechChat
      break
    case 'doctor':
      Comp = TechDoctor
      break
    case 'heart':
      Comp = TechHeart
      break
    case 'hospital':
      Comp = TechHospital
      break
    case 'personal-info':
      Comp = TechPersonalInformation
      break
    case 'banner':
      Comp = HomeBanner
      break
    case 'computer-laptop':
      Comp = ComputerLaptop
      break
    case 'explore-glass':
      Comp = ExploreMagnify
      break
    case 'heart-hug':
      Comp = HeartHug
      break
    case 'doctor-snapshot':
      Comp = DoctorSnapshot
      break
    case 'mobile-care':
      Comp = MobileCare
      break
    case 'lock':
      Comp = Lock
      break
    case 'edit-pencil':
      Comp = EditPencil
      break
    case 'light-house':
      Comp = LightHouse
      break
    case 'walking-group':
      Comp = WalkingGroup
      break
    case 'note-taking':
      Comp = NoteTaking
      break
    case 'navigating-care':
      Comp = NavigatingCare
      break
    case 'hug-care':
      Comp = Hug
      break
    case 'female-stethoscope':
      Comp = FemaleStethoscope
      break
    case 'female-stethoscope-full':
      Comp = FemaleStethoscopeFull
      break
    case 'obgyn':
      Comp = OBGYNDoctor
      break
    case 'adult-primary-care':
      Comp = AdultPrimaryCareDoctor
      break
    case 'communicationstyle':
      Comp = CommunicationStyle
      break
    case 'communicationstyle-sm':
      Comp = CommunicationStyleSm
      break
    case 'communicationstyle-md':
      Comp = CommunicationStyleMd
      break
    case 'careapproach':
      Comp = CareApproach
      break
    case 'communication':
      Comp = CommunicatingStyleNew
      break
    case 'careapproch':
      Comp = CareApprochNew
      break
    case 'careapproach-sm':
      Comp = CareApproachSm
      break
    case 'careapproach-md':
      Comp = CareApproachMd
      break
    case 'background-and-identities':
      Comp = BackgroundIdentities
      break
    case 'sharedbackground':
      Comp = SharedBackground
      break
    case 'background-and-identities-sm':
      Comp = BackgroundIdentitiesSm
      break
    case 'background-and-identities-md':
      Comp = BackgroundIdentitiesMd
      break
    case 'clinicamenities':
      Comp = ClinicAmenities
      break
    case 'clinicamenities-new':
      Comp = ClinicalAminitiesNew
      break
    case 'clinicamenities-md':
      Comp = ClinicAmenitiesMd
      break
    case 'clinicamenities-sm':
      Comp = ClinicAmenitiesSm
      break
    case 'us-map':
      Comp = USMap
      break
    case 'admin-portal':
      Comp = AdminPortal
      break
    case 'heart-campaign':
      Comp = Heart
      break
    case 'videochat-campaign':
      Comp = Videochat
      break
    case 'stopwatch-campaign':
      Comp = Stopwatch
      break
    default:
      Comp = TechStethoscope
      break
  }
  return <Comp {...boxProps} />
}

export default Illustration
// No need to export these individually; all usage should go through the Illustration component.
